// Development Configuration
// Modify this file to change development settings

export const DEV_CONFIG = {
  // API Configuration
  API_BASE_URL: 'http://localhost:8080',
  
  // Backend Configuration
  BACKEND_HOST: 'localhost',
  BACKEND_PORT: 8080,
  
  // Frontend Configuration
  FRONTEND_PORT: 3000,
  
  // Feature Flags
  ENABLE_LOGGING: true,
  ENABLE_DEBUG_MODE: true,
  
  // Mock Data (for development without backend)
  USE_MOCK_DATA: false,
  
  // CORS Settings
  CORS_ENABLED: true,
  
  // Timeout Settings
  API_TIMEOUT: 10000, // 10 seconds
  
  // Retry Settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Helper function to get full backend URL
export const getBackendUrl = (endpoint = '') => {
  return `${DEV_CONFIG.API_BASE_URL}${endpoint}`;
};

// Helper function to check if running in development
export const isDevEnvironment = () => {
  return process.env.NODE_ENV === 'development' || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.port === '3000';
};

// Export default config
export default DEV_CONFIG;
